import { message, Upload } from 'antd';
import React from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { AttachmentActions } from '../../redux/actions';
import { translate } from '../../services/i18n';

const { Dragger } = Upload;

const ExamUploader = ({ setAttachmentFiles, attachments }) => {
  const handleFileChange = (info) => {
    let { fileList } = info;

    if (info.file.status === 'removed') {
      setAttachmentFiles(fileList);
      return;
    }

    const maxFiles = 3;

    if (fileList.length > maxFiles) {
      message.error(translate('COMPONENTS.EXAM_UPLOADER.FILE_MAX'));
      fileList = fileList.slice(0, maxFiles);
    }

    const maxSize = 5 * 1024 * 1024;
    const validFiles = fileList.filter(file => {
      if (file.size > maxSize) {
        message.error(translate('COMPONENTS.EXAM_UPLOADER.FILE_LIMIT'));

        return false;
      }

      const fileName = file.name.toLowerCase();
      const isValidType = fileName.endsWith('.pdf') || fileName.endsWith('.jpg') || fileName.endsWith('.jpeg') || fileName.endsWith('.png');

      if (!isValidType) {
        message.error(translate('COMPONENTS.EXAM_UPLOADER.FILE_TYPE_ERROR'));
        return false;
      }

      return true;
    });

    setAttachmentFiles(validFiles);
  };

  return (
    <div className='exam-uploader'>
      <div className="prescription-step__single__title">{translate('COMPONENTS.EXAM_UPLOADER.TITLE')}</div>
      <Dragger
        multiple
        accept=".pdf,.jpg,.jpeg,.png"
        beforeUpload={() => false}
        onChange={handleFileChange}
        className='exam-dragger'
        fileList={attachments}
      >
        <InboxOutlined className='exam-icon' />
        <p>{translate('COMPONENTS.EXAM_UPLOADER.DRAG_AND_DROP_MESSAGE')}</p>
        <p>{translate('COMPONENTS.EXAM_UPLOADER.DRAG_AND_DROP_MESSAGE_TWO')}</p>
      </Dragger>
    </div>
  );
};

const mapStateToProps = (state) => ({
  attachments: state.attachment.files,
});

const mapDispatchToProps = (dispatch) => ({
  setAttachmentFiles: (files) => dispatch(AttachmentActions.setAttachmentFiles(files)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExamUploader);
